import { useState } from 'react';

import { useLocation } from 'react-router-dom';
import { IIndexSignature } from '@selfserve/react-utils';

const paramsToObject = (entries: Iterable<string>) => {
  const result: IIndexSignature<string> = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
};

export const useQueryParams = () => {
  const { search } = useLocation();
  const [queryParams] = useState(
    paramsToObject((new URLSearchParams(search) as any).entries() as Iterable<string>)
  );
  return queryParams;
};
